export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12.519 3.627a5.554 5.554 0 017.854 7.855l-8.891 8.891a5.554 5.554 0 01-7.855-7.854l8.892-8.892zM5.041 13.934a3.553 3.553 0 105.026 5.025l3.74-3.74-5.026-5.024-3.74 3.739zM18.96 5.04a3.554 3.554 0 00-5.025 0l-3.74 3.74 5.026 5.025 3.74-3.74a3.554 3.554 0 000-5.025z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};